import { melownNode } from "./utils";
import Melown3dCompass from "./compass";

export default class Melown3dBasicCompass extends Melown3dCompass {
	_needle: HTMLDivElement;

	_rootEl: HTMLDivElement;

	/**
	 * Kompas.
	 *
	 * @param {Function} [cb] Callback kliknuti na kompas
	 * @param {Object} [scope] Scope
	 *
	 */
	constructor(cb: () => void, scope: any, trans: {[key: string]: string}) {
		super(cb, scope, trans);

		this._needle = null;

		this._build();
	}

	/**
	 * Zmena uhlu yaw.
	 *
	 * @param  {Number} yaw Uhel otoceni
	 */
	setYaw(yaw: number) {
		const newYaw = typeof yaw === "number" ? -yaw : 0;

		this._needle.style.transform = `rotate(${newYaw}deg)`;
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_build() {
		// kompas
		const compass = melownNode("div", { className: "basic-compass noprint" });
		const needle = melownNode("div", { className: "needle" });

		compass.appendChild(needle);

		// kliknutim se dostaneme zpatky na sever
		compass.addEventListener("dblclick", () => {
			this._runCb();
		});

		this._rootEl = compass;
		this._needle = needle;
	}
}
